module.exports = __webpack_public_path__ + "img/pagination1-icon.b3d3ded6.png";